import * as type from '../actions/actionType';

const authReducer = (state = {}, action) => {

  switch (action.type) {
    case type.LOGIN_SUCCESS:
      return {
        ...state,
        inProgress: false,
        response: action.data,
        redirectTo: action.success ? "/dashboard" : null,
      }
  }
  return state;
};

export default authReducer;
